import { TypeExamStatus } from 'app/constants/types/exam.types';
import dayjs from 'dayjs';

/**
 * Maps the combined exam status (API status + enrollment status) to a display status
 * 
 * @param examStatus Original exam status from API
 * @param isEnrolled Whether the user is enrolled in this exam
 * @param examTime Exam end time for checking submission window
 * @param hasSubmission Whether the user has submitted the exam
 * @returns Mapped exam status for display
 */
export const mapExamStatus = (
  examStatus: string, 
  isEnrolled: boolean | undefined, 
  examTime: string, 
  examDuration: string,
  hasSubmission: boolean
): TypeExamStatus => {
  // Handle undefined or empty status
  if (!examStatus) {
    return "pending" as TypeExamStatus;
  }

  // Handle undefined enrollment status (default to false)
  const userEnrolled = isEnrolled === true;
  
  // Not enrolled cases
  if (!userEnrolled) {
    if (["standby-locked", "standby-open", "ongoing"].includes(examStatus)) {
      return "open";
    }
    if (["ended", "results-released"].includes(examStatus)) {
      return "close";
    }
  }
  // Enrolled cases
  else {
    if (examStatus === "standby-locked") {
      return "standby";
    }
    if (examStatus === "standby-open") {
      return "countdown";
    }
    if (examStatus === "ended") {
      // Check for missing submissions (within 1 hour of end)
      if (examTime) {
        try {


      
          // Convert exam duration string to milliseconds (assuming format like "1 hour")
          const durationInMs = examDuration === '1 hour' ? 3600000 : 0; // 1 hour in milliseconds
          
          const startTime = dayjs(examTime).valueOf();
          const endTime = startTime + durationInMs;
          const currentTime = dayjs().valueOf();

          console.log('Exam start time:', startTime);
          console.log('Exam duration:', durationInMs, 'ms');
          console.log('Exam end time:', endTime);
          console.log('Current time:', currentTime);
          
          if (currentTime - endTime <= durationInMs && !hasSubmission) {
            return "missing";
          }
        } catch (error) {
          console.error('Error parsing exam end time:', error);
          // If there's an error parsing the date, just return the default status
        }
      }
      return "ended";
    }
    if (examStatus === "results-released") {
      return "graded";
    }
  }
  
  // Default: return original status
  return examStatus as TypeExamStatus;
};
